import { UploadOutlined } from "@ant-design/icons";
import { Button, message, Modal, Upload } from "antd";
import React, { useState } from "react";
import { uploadComprobantePago } from "../../../lib/uploadComprobantePago";



const ModalComprobantePago = ({ show, setShow, selectedInvoice, onSuccess }) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.warning("Debes seleccionar un archivo.");
      return;
    }
    debugger
    const formData = new FormData();
    formData.append("comprobante", fileList[0]); // solo uno

    setUploading(true);
    try {
      debugger
      await uploadComprobantePago(selectedInvoice._id, formData)
      // await axios.put(`/api/invoices/comprobante/${id}`, formData, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //   },
      // });

      message.success("✔️ Comprobante subido con éxito.");
      setFileList([]);
      setShow(false);
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error);
      message.error("❌ Error al subir el comprobante.");
    } finally {
      setUploading(false);
    }
  };

  const props = {
    beforeUpload: (file) => {
      setFileList([file]); // sólo uno a la vez
      return false; // evita upload automático
    },
    onRemove: () => {
      setFileList([]);
    },
    fileList,
  };

  return (
    <Modal
      title="Subir comprobante de pago"
      open={show}
      onCancel={() => setShow(false)}
      footer={[
        <Button key="cancel" onClick={() => setShow(false)}>
          Cancelar
        </Button>,
        <Button
          key="upload"
          type="primary"
          loading={uploading}
          onClick={handleUpload}
        >
          Subir
        </Button>,
      ]}
    >
      <Upload {...props}>
        <Button icon={<UploadOutlined />}>Seleccionar archivo</Button>
      </Upload>
      <p style={{ marginTop: "10px" }}>
        Archivos permitidos: PDF, JPG, PNG. Tamaño máximo: ~5MB
      </p>
    </Modal>
  );
};

export default ModalComprobantePago;
